import AbsComponent from '../../common/components/AbsComponent';
import Templ from './GuildTempl';

/**
 * Guild class
 * @category mainApp
 */
class Guild extends AbsComponent{
	constructor(_store = {}, _el = '') {
		super(_store, _el);

		if (this.store.getData('config').isLogin ) {
			let stateNochar = userData.accountState.filter( it => it.case==3 ); // 보유 캐릭터 없음
			let stateBoss = userData.accountState.filter( it => it.case==1 ); // 대표 캐릭터 미선택
			let stateNoname = userData.accountState.filter( it => it.case==2 || it.case==6 ); // 비실명
			let stateBlock = userData.accountState.filter( it => it.case==7 || it.case==8 ); // 제재

			if (stateNochar.length>0){
				$(this.el).append( Templ.noData('stateNochar') );
				return false;
			}
			if (stateBoss.length>0){
				$(this.el).append( Templ.noData('stateBoss') );
				return false;
			}
			if (stateNoname.length>0){
				$(this.el).append( Templ.noData('stateNoname') );
				return false;
			}
			if (stateBlock.length>0){
				$(this.el).append( Templ.noData('stateBlock') );
				return false;
			}

			if( this.store.getData('config').userData.representativeCharacter.guild ) {
				this.store.getData('Guild', {}, this.render.bind(this));
				$(this.el + ' .loading-wrap').show();
			} else {
				$(this.el).append( Templ.noData('Nojoin') ); // 문파 가입 안함
			}

		}
	}

	render(_jsonData = {}) {
		this.data = _jsonData.data;
		// console.log( 'guild Error : ', _jsonData );
		if(_jsonData.error == 'Forbidden' || _jsonData.exceptionClassName == 'UnsubscribedGuildException') { // 가입된 문파가 없음
			$(this.el).append( Templ.noData() );
			return;
		}

		const counter = Templ.getCounter(_jsonData);
		const guildName = this.store.getData('config').userData.gameAccount.guildName;
		$(this.el + ' .loading-wrap').hide();
		$(this.el).append(Templ.getTempl(_jsonData,  this.store.data.config.profileDomain, this.store.data.config.sandboxDomain ));

		TweenMax.fromTo([this.el + ' .guild-list'], 0.5, {opacity: 0, y: 20}, {opacity: 1, y: 0});
		TweenMax.fromTo([this.el + ' .nodata'], 0.5, {opacity: 0}, {opacity: 1});

		if(counter > 0) $('.guild-count').append(Templ.getCounter(_jsonData)).removeClass('is-hide').addClass('is-show');
		if(guildName) $('.guild-myguild').append( guildName ).removeClass('is-hide').addClass('is-show');

		this.setting();
		this.addEvents();
	}

	setting(){
	}

	addEvents(){
		$(this.el + ' button.btn-gift ').on('click', (e)=>{
			const svrid = userData.representativeCharacter.serverId;
			const charName = $(e.currentTarget).data('charname');
			 window.ncoinGiftPopup.open(svrid, charName);
            //window.ncrwd.ncoin.open(ip, svrid, charName);
		});
	}
}

export default Guild;